import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaSchool } from "react-icons/fa6";
import { ClipLoader } from "react-spinners";
import localization from "services/localization";
import { Button as BsButton } from "react-bootstrap";
import { toast } from "react-toastify";
import SpecificAPI from "services/SpecificApi";
import { useSchoolsStore } from "context/useSchoolsStore";
import { useUserRightsStore } from "context/useUserRightsStore";
import AddEditOrganizationModal from "./AddEditOrganizationModal";
import AddCreditOrganizationModal from "./AddCreditOrganizationModal";

import DeleteModal from "views/Components/DeleteModal";
import { OrganizationCard } from "views/Components/OrganizationCard";
import { useUserStore } from "context/useUserStore";
import { useDepartmentsStore } from "context/useDepartmentsStore";
import { School } from "lucide-react";
import { useLanguageStore } from "context/useLanguageStore";

const emptyOrganization = {
  name: "",
  type: "school",
  code: "",
  codice_meccanografico: "",
  address: "",
  city: "",
  province: "",
  postal_code: "",
  region: "",
  country: "",
  contact_email: [],
  contact_phone: [],
  website: [],
  pec: [],
  dirigente_scolastico: "",
  description: "",
  extra_info: "",
  piva: "",
  codice_fiscale: "",
  sub_type: null,
  institution_logo: null,
  organization_logo: null,
};

const OrganizationPage = () => {
  const { currentLang } = useLanguageStore();
  const { schools, setSchools, isSchoolsLoading } = useSchoolsStore();
  const { userCanPerform } = useUserRightsStore();
  const [loading, setLoading] = useState(false);
  const [showAddOrganizationModal, setShowAddOrganizationModal] =
    useState(false);
  const navigate = useNavigate();

  const [showAddEditOrganization, setShowAddEditOrganization] = useState(false);
  const [showAddCreditOrganization, setShowAddCreditOrganization] =
    useState(false);
  const [editingItem, setEditingItem] = useState(emptyOrganization);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [itemName, setItemName] = useState("");
  const [errors, setErrors] = useState({});
  const { userData, appUser, setUserAppData, setAppUser } = useUserStore();
  const { loadDepartmentsBySchool } = useDepartmentsStore();

  useEffect(() => {
    if (!appUser) return;
    if (isSchoolsLoading) return;

    if (schools.length === 1 && appUser.role !== "root") {
      handleEnterOrganization(schools[0]);
      return;
    }

    if (appUser.role === "student" && schools.length > 0) {
      navigate("/departments");
    }
  }, [schools, appUser, isSchoolsLoading]);

  const handleEnterOrganization = (school) => {
    setUserAppData({
      ...userData,
      selected_school_id: school.id,
      selected_school: school,
    });

    if (schools.length != 1 || school.id != schools[0].id) {
      loadDepartmentsBySchool(school.id);
    }

    console.log("role in SchoolPage:", appUser?.role);
    {
      appUser?.role == "root"
        ? navigate(`/edu-prompt/department-management`)
        : navigate(`/departments`);
    }
  };

  const validateForm = (form) => {
    const requiredFields = [
      { name: "name", label: localization.name_required || "Name is required" },
      { name: "code", label: localization.code_required || "Code is required" },
      { name: "city", label: localization.city_required || "City is required" },
      {
        name: "address",
        label: localization.address_required || "Address is required",
      },
      {
        name: "province",
        label: localization.province_required || "Province is required",
      },
      {
        name: "postal_code",
        label: localization.postal_code_required || "Postal code is required",
      },
      {
        name: "region",
        label: localization.region_required || "Region is required",
      },
      {
        name: "country",
        label: localization.country_required || "Country is required",
      },
      {
        name: "type",
        label:
          localization.organization_type_required ||
          "Select an organization type",
      },
      {
        name: "codice_meccanografico",
        label:
          localization.codice_meccanografico_required ||
          "Code Meccanografico is required",
      },
      {
        name: "dirigente_scolastico",
        label:
          localization.dirigente_scolastico_required ||
          "Dirigente Scolastico is required",
      },
      {
        name: "description",
        label: localization.description_required || "description is required",
      },
      {
        name: "extra_info",
        label: localization.extra_info_required || "Extra info is required",
      },
      {
        name: "codice_meccanografico",
        label:
          localization.codice_meccanografico_required ||
          "Codice Meccanografico is required",
      },
      {
        name: "piva",
        label: localization.piva_required || "P.IVA is required",
      },
    ];

    const e = {};

    requiredFields.forEach((field) => {
      if (!form[field.name] || !form[field.name].toString().trim()) {
        e[field.name] = field.label;
      }
    });

    if (!form.pec || form.pec.length === 0) {
      e.pec = localization.pec_required || "PEC is required";
    }

    return e;
  };
  const handleSubmit = async (data) => {
    const validationErrors = validateForm(data);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});

    try {
      setLoading(true);
      if (editingItem?.id) {
        const res = await SpecificAPI.updateOrganization({
          ...data,
          _id: editingItem.id,
        });
        setSchools((prev) =>
          prev.map((s) => (s.id === editingItem.id ? res.data : s)),
        );
        toast.success(
          localization.organization_saved || "Organization updated!",
        );
      } else {
        if (data.organization_logo === "" || data.organization_logo === null) {
          delete data.organization_logo;
        }
        if (data.institution_logo === "" || data.institution_logo === null) {
          delete data.institution_logo;
        }
        if (data.sub_type === "" || data.sub_type === null) {
          delete data.sub_type;
        }
        const created = await SpecificAPI.createOrganization(data);
        try {
          const updatedUser = {
            ...appUser,
            school_id: [...(appUser.school_id || []), created.data.id],
          };
          await SpecificAPI.updateUser(appUser.id, {
            school_id: [...(appUser.school_id || []), created.data.id],
          });

          setAppUser(updatedUser);
        } catch (userUpdateError) {
          console.error(
            "Failed to update user with new school:",
            userUpdateError,
          );
          toast.error("Failed to add new school to your user account.");
        }
        setSchools((prev) => [...prev, created.data]);
        toast.success(
          localization.organization_saved || "Organization created!",
        );
      }
      setShowAddEditOrganization(false);
      setShowAddCreditOrganization(false);
      setEditingItem(emptyOrganization);
    } catch (err) {
      console.error(err);
      toast.error(
        err?.response?.data?.error ||
          localization.failed_to_save_organization ||
          "Failed to save organization",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (school) => {
    setEditingItem(school);
    setShowAddEditOrganization(true);
    setErrors({});
  };

  const handleCredit = (school) => {
    setEditingItem(school);
    setShowAddCreditOrganization(true);
    setErrors({});
  };

  const handleDelete = (school) => {
    setItemToDelete(school);
    setItemName(school.name);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!itemToDelete) return;

    try {
      setLoading(true);
      await SpecificAPI.deleteOrganization(itemToDelete.id);
      const updatedSchoolIds = (appUser.school_id || []).filter(
        (id) => id !== itemToDelete.id,
      );
      await SpecificAPI.updateUser(appUser.id, {
        school_id: updatedSchoolIds,
      });

      setAppUser({
        ...appUser,
        school_id: updatedSchoolIds,
      });

      setSchools((prev) => prev.filter((s) => s.id !== itemToDelete.id));
      toast.success(
        localization.organization_deleted || "Organization deleted!",
      );
    } catch (err) {
      console.error(err);
      toast.error(
        localization.failed_to_delete_school || "Failed to delete school",
      );
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
      setItemToDelete(null);
    }
  };

  const handleFormChange = (name, value) => {
    setEditingItem((prev) => {
      if (!prev) return { ...emptyOrganization, [name]: value };
      return { ...prev, [name]: value };
    });

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const showAddOrganization = appUser?.role === "root";

  return (
    <div className="mb-5 w-100">
      <div className="p-16 h-full main-page w-100">
        <div className="container mb-4">
          <div className="d-flex justify-content-between align-items-stretch">
            {/* LEFT SIDE */}
            <div className="d-flex align-items-center gap-3">
              {" "}
              {/* Icon */}
              <div className="title-icon-bg d-flex h-12 w-12 align-items-center justify-content-center rounded-xl shadow-md ms-3">
                {" "}
                <School size={28} className="title-icon" />
              </div>
              {/* Title + Subtitle */}
              <div className="d-flex flex-column justify-content-between">
                <div className="d-flex flex-column">
                  <h1 className="text-3xl font-bold m-0 page-title">
                    {localization.your_organizations || "Your Organizations"}
                  </h1>

                  <p className="text-base m-0 page-subtitle">
                    {localization.enter_organization_to_manage ||
                      "Enter organization to manage"}
                  </p>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE BUTTON */}
            {showAddOrganization && (
              <div className="d-flex align-items-end me-3">
                {" "}
                <BsButton
                  className="action-btn"
                  onClick={() => {
                    setShowAddEditOrganization(true);
                    setEditingItem(emptyOrganization);
                    setErrors({});
                  }}
                >
                  + {localization.add_organization || "Add Organization"}
                </BsButton>
              </div>
            )}
          </div>
        </div>

        {/* Classrooms Grid */}
        {loading ? (
          <div className="flex justify-center items-center h-40">
            <ClipLoader size={40} color="var(--primary-icon)" />
          </div>
        ) : (
          <div className="container">
            <div
              className="row g-4 p-6 justify-content-start"
              id="organizations"
            >
              {schools?.length > 0 ? (
                schools
                  .filter((s) => userCanPerform("schools", "read", s.id))
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((school) => (
                    <div key={school.id} className="col-12 col-md-6 col-lg-6">
                      <OrganizationCard
                        school={school}
                        onEnter={handleEnterOrganization}
                        showActions={appUser?.role === "root"}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        onCredit={handleCredit}
                      />
                    </div>
                  ))
              ) : (
                <p className="text-center page-subtitle">
                  No schools are assigned to this super admin.
                </p>
              )}
            </div>
          </div>
        )}
      </div>
      <AddEditOrganizationModal
        show={showAddEditOrganization}
        title={
          editingItem?.id
            ? localization.edit_organization || "Edit Organization"
            : localization.add_organization || "Add Organization"
        }
        formData={editingItem}
        onChange={handleFormChange}
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(editingItem);
        }}
        onClose={() => {
          setShowAddEditOrganization(false);
          setEditingItem(emptyOrganization);
        }}
        loading={loading}
        errors={errors}
      />
      <AddCreditOrganizationModal
        show={showAddCreditOrganization}
        title={localization.add_credit || "Add Credit"}
        formData={editingItem}
        onChange={handleFormChange}
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(editingItem);
        }}
        onClose={() => {
          setShowAddCreditOrganization(false);
          setEditingItem(emptyOrganization);
        }}
        loading={loading}
        errors={errors}
      />
      <DeleteModal
        show={showDeleteModal}
        itemName={itemName}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        loading={loading}
        setLoading={setLoading}
      />
    </div>
  );
};

export default OrganizationPage;
